import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/store";
import { Link } from "react-router-dom";
import { Placeholder } from "../components/Placeholder";
import { selectLounges } from "../redux/lounges/selectors";
import { usersSelector } from "../redux/users/selectors";
import { CommentReply } from "../components/CommentReply";
import { LoungeHeader } from "../components/LoungeHeader";
import { MobileLoungeHeader } from "../components/MobileLoungeHeader";
import { LikeCommentReply } from "../components/LikeCommentReply";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { GET_BASE_URL_IMAGE, dTime } from "../constants/apiEndpoints";
import { getAllLoungeDetailApi } from "../api/getLoungeDetail";
import { getWDWdet } from "../api/getWDWdet";

// @ts-ignore
import { Helmet } from "react-helmet-async";

import {
  fetchMyNotification,
  postLoungeFlag,
  fetchStickerLounges,
  removeUserLounge,
  deleteConversionMessage,
  sendDmMessageReply,
} from "../redux/lounges/slice";

const hasValidSession = (token: string | null, userId: string | null) => {
  return Boolean(
    token &&
      userId &&
      userId !== "null" &&
      userId !== "undefined"
  );
};

const getPlainTextPreview = (html?: string) =>
  (html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 160);

const getBackendMessageText = (message?: any): string => {
  if (!message) return "";
  if (typeof message === "object") {
    return getBackendMessageText(
      message.data || message.message || message.error || ""
    );
  }

  return String(message)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const getNotificationDateValue = (item: any) => {
  const time = new Date(item?.createdon || 0).getTime();
  return Number.isNaN(time) ? 0 : time;
};

const getDmGroupKey = (item: any) =>
  `message-group:${String(item?.user_id || item?.user_name || "unknown")}`;

const getLatestDmMessage = (messages: any[]) =>
  [...messages].sort(
    (first, second) =>
      getNotificationDateValue(second) - getNotificationDateValue(first)
  )[0];

const getGroupedNotifications = (items: any[] = []) => {
  const rows: any[] = [];
  const dmRowsByUser = new Map<string, any>();

  items.forEach((item, index) => {
    if (item?.type !== "m") {
      rows.push({ kind: "item", item, originalIndex: index });
      return;
    }

    const groupKey = getDmGroupKey(item);
    const existingRow = dmRowsByUser.get(groupKey);

    if (existingRow) {
      existingRow.messages.push(item);
      return;
    }

    const dmRow = {
      kind: "dm-group",
      groupKey,
      messages: [item],
      originalIndex: index,
    };

    dmRowsByUser.set(groupKey, dmRow);
    rows.push(dmRow);
  });

  dmRowsByUser.forEach((row) => {
    row.messages = [...row.messages].sort(
      (first, second) =>
        getNotificationDateValue(first) - getNotificationDateValue(second)
    );
  });

  return rows;
};

const getCommentNotificationKey = (item: any) =>
  `comment:${String(item?.chat_room_name || "DL")}:${String(
    item?.chat_id
  )}:${String(item?.chat_reply_id)}`;

const getDetailComments = (detailData: any) =>
  Array.isArray(detailData?.[0]?.comments) ? detailData[0].comments : [];

const findNotificationCommentInDetail = (item: any, detailData: any) =>
  getDetailComments(detailData).find(
    (comment: any) =>
      String(comment?.chat_reply_id) === String(item?.chat_reply_id)
  );

const getNotificationReplyData = (
  item: any,
  repliesByCommentKey: Record<string, any[]>
) => {
  const key = getCommentNotificationKey(item);
  if (Object.prototype.hasOwnProperty.call(repliesByCommentKey, key)) {
    return repliesByCommentKey[key];
  }

  return Array.isArray(item?.commentsreply) ? item.commentsreply : [];
};

const Notification = () => {
  const dispatch = useAppDispatch();
  const { myNotificationItem, stickerItems } = useSelector(selectLounges);
  //console.log('uyoga');
  const token = localStorage.getItem("token");
  const loginuser = localStorage.getItem("user_id");
  const isSessionReady = hasValidSession(token, loginuser);
  const { isLoggedIn } = useSelector(usersSelector);
  const [LoungeId, setLoungeId] = useState<number | any>("");
  const [Type, setFlagType] = useState<string>("R");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isNotificationLoading, setIsNotificationLoading] =
    useState<boolean>(true);
  const [notificationLoadError, setNotificationLoadError] = useState<
    string | null
  >(null);

  type FormData = {
    ReasonForReport: string;
    LoungeId: number;
    Type: string;
  };

  useEffect(() => {
    setValue("Type", Type);
    setValue("LoungeId", LoungeId);
  }, [Type, LoungeId]);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const sortType: any = null;

  const loadNotifications = useCallback(() => {
    if (!isSessionReady) {
      setNotificationLoadError(null);
      setIsNotificationLoading(false);
      return;
    }

    setNotificationLoadError(null);
    setIsNotificationLoading(true);

    dispatch(fetchMyNotification({ sortType, currentPage }))
      .unwrap()
      .catch((error) => {
        console.error("fetchMyNotification failed", error);
        setNotificationLoadError("Please try to open the page later.");
      })
      .finally(() => {
        setIsNotificationLoading(false);
      });
  }, [dispatch, currentPage, isSessionReady]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadNotifications();
  }, [loadNotifications]);

  //console.log(myNotificationItem);

  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
    return formattedDate;
  }

  const [activeReplyKey, setActiveReplyKey] = useState<string | null>(null);
  const [activeMessageReplyKey, setActiveMessageReplyKey] = useState<
    string | null
  >(null);
  const [messageReplyText, setMessageReplyText] = useState("");
  const [messageReplySubmittingKey, setMessageReplySubmittingKey] = useState<
    string | null
  >(null);
  const [messageReplyError, setMessageReplyError] = useState<string | null>(
    null
  );
  const [commentRepliesByNotificationKey, setCommentRepliesByNotificationKey] =
    useState<Record<string, any[]>>({});
  const [
    commentReplyLoadingByNotificationKey,
    setCommentReplyLoadingByNotificationKey,
  ] = useState<Record<string, boolean>>({});
  const [stickersLoaded, setStickersLoaded] = useState(false);
  const RemoveType = "C";

  const loadNotificationCommentThread = useCallback(async (item: any) => {
    if (!item?.chat_id || !item?.chat_reply_id) return;

    const key = getCommentNotificationKey(item);
    setCommentReplyLoadingByNotificationKey((previous) => ({
      ...previous,
      [key]: true,
    }));

    try {
      const detailData =
        item?.chat_room_name === "WDW"
          ? await getWDWdet({ LoungeId: item.chat_id })
          : await getAllLoungeDetailApi({ LoungeId: item.chat_id });
      const matchingComment = findNotificationCommentInDetail(item, detailData);
      setCommentRepliesByNotificationKey((previous) => ({
        ...previous,
        [key]: Array.isArray(matchingComment?.commentsreply)
          ? matchingComment.commentsreply
          : [],
      }));
    } catch (error) {
      console.error("notification comment thread fetch failed", error);
      setCommentRepliesByNotificationKey((previous) => ({
        ...previous,
        [key]: Array.isArray(item?.commentsreply) ? item.commentsreply : [],
      }));
    } finally {
      setCommentReplyLoadingByNotificationKey((previous) => ({
        ...previous,
        [key]: false,
      }));
    }
  }, []);

  useEffect(() => {
    if (!isSessionReady) return;

    const commentNotifications = myNotificationItem.filter(
      (item: any) => item?.type === "c" && item?.chat_id && item?.chat_reply_id
    );

    commentNotifications.forEach((item: any) => {
      const key = getCommentNotificationKey(item);
      if (
        Object.prototype.hasOwnProperty.call(
          commentRepliesByNotificationKey,
          key
        )
      ) {
        return;
      }

      loadNotificationCommentThread(item);
    });
  }, [
    commentRepliesByNotificationKey,
    isSessionReady,
    loadNotificationCommentThread,
    myNotificationItem,
  ]);

  const ensureStickerData = useCallback(() => {
    if (stickersLoaded) return;
    localStorage.removeItem("userid");
    setStickersLoaded(true);
    let emojiData: any = null;
    dispatch(fetchStickerLounges({ emojiData }));
  }, [dispatch, stickersLoaded]);

  const toggleReplyFor = useCallback(
    (chatId: any, chatReplyId: any) => {
      const replyKey = `${String(chatId)}:${String(chatReplyId)}`;
      setActiveReplyKey((prevKey) => (prevKey === replyKey ? null : replyKey));
      ensureStickerData();
    },
    [ensureStickerData]
  );

  const getMessageReplyKey = (obj: any, index: number) =>
    `message:${String(obj.chat_id)}:${String(obj.user_id)}:${String(
      obj.createdon || index
    )}`;

  const toggleMessageReplyFor = (obj: any, index: number) => {
    const replyKey = getMessageReplyKey(obj, index);
    setActiveMessageReplyKey((prevKey) => {
      const nextKey = prevKey === replyKey ? null : replyKey;
      if (nextKey !== prevKey) {
        setMessageReplyText("");
        setMessageReplyError(null);
      }
      return nextKey;
    });
  };

  const closeMessageReply = () => {
    setActiveMessageReplyKey(null);
    setMessageReplyText("");
    setMessageReplyError(null);
  };

  const submitMessageReply = (obj: any, replyKey: string) => {
    if (messageReplySubmittingKey === replyKey) return;

    if (!messageReplyText.trim()) {
      setMessageReplyError("Please enter a reply.");
      return;
    }

    setMessageReplyError(null);
    setMessageReplySubmittingKey(replyKey);
    dispatch<any>(
      sendDmMessageReply({
        user_id: obj.user_id,
        user_text_message: messageReplyText.trim(),
      })
    )
      .then((res: any) => {
        const responseMessage = getBackendMessageText(
          res?.payload?.data || res?.payload || res?.error?.message
        );

        if (
          res?.error ||
          !/Your Message sent successfully/i.test(responseMessage)
        ) {
          setMessageReplyError(
            responseMessage || "Your reply could not be sent. Please try again."
          );
          return;
        }

        closeMessageReply();
        loadNotifications();
      })
      .catch(() => {
        setMessageReplyError("Your reply could not be sent. Please try again.");
      })
      .finally(() => {
        setMessageReplySubmittingKey(null);
      });
  };

  const onRemove = (ban_chat_id: any) => {
    dispatch<any>(removeUserLounge({ ban_chat_id, RemoveType })).then(
      (res: any) => {
        window.location.reload();
        // Notify(toast('Comment Removed'));
      }
    );
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  function openModal(id: any) {
    setIsOpen(true);
    setLoungeId(id);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "100%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      background: "#F5F5F5",
      transform: "translate(-50%, -50%)",
    },
  };

  const onSubmit = (data: any) => {
    dispatch<any>(postLoungeFlag(data)).then((res: any) => {
      reset();
      setIsOpen(false);
    });
  };

  const deleteConversion = (e: any, msg_id: any) => {
    dispatch<any>(deleteConversionMessage({ msg_id })).then((res: any) => {
      loadNotifications();
    });
  };

  const next = () => {
    if (currentPage >= 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const groupedNotificationRows = getGroupedNotifications(myNotificationItem);

  return (
    <>
      <Helmet>
        <title>My Notifications</title>
        <meta property="og:title" content="Mousewait" />
        <meta
          property="og:image"
          content="https://mousewait.com/static/media/MouseWait-img.fed12113160621608cfe.png"
        />
        <meta
          property="og:description"
          content="MouseWait provides a wealth of information for both casual and frequent visitors to the Disneyland Resort. It does exactly what it claims and more, and it does it extremely well. "
        />
      </Helmet>

      <div className="mid-main">
        <div className="container">
          <div className="mid-sec mwstore-page-bg">
            <LoungeHeader />
            <MobileLoungeHeader />
            {/* <ToastContainer autoClose={3000} /> */}

            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Report notification item"
            >
              <form
                className="space-y-6"
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
              >
                <div className="row">
                  <div className="box-t-1">
                    <h6
                      style={{
                        fontSize: "1rm",
                        fontWeight: 400,
                        color: "red",
                      }}
                    >
                      Report
                    </h6>

                    <div className="close-p" onClick={closeModal}>
                      <i className="fa fa-close my-b" />
                    </div>
                    <div className="boxwidth">
                      <div className="box-ttt">
                        <textarea
                          rows={3}
                          cols={60}
                          placeholder="write reason for reporting"
                          {...register("ReasonForReport")}
                        />

                        <input
                          type="hidden"
                          {...register("LoungeId")}
                          defaultValue={LoungeId}
                        />
                        <div className="mw-post text-center">
                          <input
                            className="MW-btn"
                            type="Submit"
                            value="Post"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </Modal>

            {/* dm message reply modal ends here  */}

            <div className="des-bg">
              <>
                {!isSessionReady ? (
                  <div className="mid-card-sec">
                    <div className="card-mn rounded">
                      <div className="card-body">
                        Please login to see your Notifications.
                      </div>
                    </div>
                  </div>
                ) : notificationLoadError ? (
                  <div className="content__error-info">
                    <h2>Error</h2>
                    <p>{notificationLoadError}</p>
                  </div>
                ) : (
                  <div className="mid-card-sec">
                    {isNotificationLoading
                      ? [...new Array(9)]?.map((_, index) => (
                          <Placeholder key={index} />
                        ))
                      : groupedNotificationRows?.map((row, index) => {
                          if (row.kind === "dm-group") {
                            const dmMessages = row.messages;
                            const latestMessage =
                              getLatestDmMessage(dmMessages) || dmMessages[0];
                            const replyKey = getMessageReplyKey(
                              latestMessage,
                              index
                            );

                            return (
                              <div key={row.groupKey}>
                                <div className="card-mn rounded">
                                  <div className="card-body">
                                    <div className="d-flex flex-row">
                                      <div className="notifications-s">
                                        <div className="not-s">
                                          <div className="d-flex">
                                            <div className="flex-shrink-0">
                                              <div className="img-cs">
                                                <a
                                                  href={`/disneyland/user/${latestMessage.user_id}/mypost`}
                                                >
                                                  <img
                                                    src={
                                                      GET_BASE_URL_IMAGE +
                                                      "/disneyland/images/thumbs/" +
                                                      latestMessage.image +
                                                      dTime
                                                    }
                                                    className="card-img-top img-fluid"
                                                    alt="img"
                                                    loading="lazy"
                                                    decoding="async"
                                                  />
                                                </a>
                                              </div>
                                            </div>

                                            <div className="not-text flex-grow-1">
                                              <div className="not-p">
                                                <div className="mw-notification-dm-heading">
                                                  <span>
                                                    Conversation with
                                                    <a
                                                      className="text-black"
                                                      style={{
                                                        marginLeft: "0.5rem",
                                                      }}
                                                      href={`/disneyland/user/${latestMessage.user_id}/mypost`}
                                                    >
                                                      {latestMessage.user_name}
                                                    </a>
                                                  </span>
                                                  {dmMessages.length > 1 && (
                                                    <span className="mw-notification-dm-count">
                                                      {dmMessages.length} messages
                                                    </span>
                                                  )}
                                                </div>

                                                <div className="mw-notification-dm-thread">
                                                  {dmMessages.map(
                                                    (message: any) => (
                                                      <div
                                                        className="mw-notification-dm-message"
                                                        key={`${message.chat_id}-${message.createdon}`}
                                                      >
                                                        {message.chat_msg && (
                                                          <span
                                                            className="notification-msg-html mw-notification-dm-message-text"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                message.chat_msg
                                                                  ?.replace(
                                                                    "<p>",
                                                                    "<span>"
                                                                  )
                                                                  .replace(
                                                                    "</p>",
                                                                    "</span>"
                                                                  )
                                                                  .replace(
                                                                    "<br>",
                                                                    ""
                                                                  ),
                                                            }}
                                                          ></span>
                                                        )}
                                                        <span className="com-tt mw-notification-dm-date">
                                                          {converDate(
                                                            message.createdon
                                                          )}
                                                        </span>
                                                        <button
                                                          type="button"
                                                          className="mw-notification-dm-delete"
                                                          onClick={(e) => {
                                                            if (
                                                              window.confirm(
                                                                "Are you sure ?"
                                                              )
                                                            )
                                                              deleteConversion(
                                                                e,
                                                                message.chat_id
                                                              );
                                                          }}
                                                        >
                                                          Delete
                                                        </button>
                                                      </div>
                                                    )
                                                  )}
                                                </div>

                                                <span className="not-1 item-lisst notification-action-row mw-comment-actions">
                                                  <button
                                                    type="button"
                                                    className="mw-comment-action"
                                                    onClick={() =>
                                                      toggleMessageReplyFor(
                                                        latestMessage,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    Reply DM
                                                  </button>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {activeMessageReplyKey === replyKey && (
                                      <div className="mw-inline-reply mw-notification-inline-reply">
                                        <div className="mw-inline-reply-context">
                                          <div className="mw-inline-reply-copy">
                                            <span className="mw-inline-reply-kicker">
                                              Replying to private message
                                            </span>
                                            <strong>
                                              {latestMessage.user_name}
                                            </strong>
                                            <span>
                                              This reply will continue this
                                              private DM conversation.
                                            </span>
                                          </div>
                                          <div className="mw-inline-reply-actions">
                                            <button
                                              type="button"
                                              onClick={() =>
                                                submitMessageReply(
                                                  latestMessage,
                                                  replyKey
                                                )
                                              }
                                              className="mw-inline-reply-send mw-notification-reply-submit mw-notification-reply-submit--context"
                                              disabled={
                                                messageReplySubmittingKey ===
                                                replyKey
                                              }
                                            >
                                              {messageReplySubmittingKey ===
                                              replyKey
                                                ? "Sending..."
                                                : "Send DM"}
                                            </button>
                                            <button
                                              type="button"
                                              onClick={closeMessageReply}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                        {getPlainTextPreview(
                                          latestMessage.chat_msg
                                        ) && (
                                          <div className="mw-inline-reply-preview">
                                            {getPlainTextPreview(
                                              latestMessage.chat_msg
                                            )}
                                          </div>
                                        )}

                                        <form
                                          onSubmit={(event) => {
                                            event.preventDefault();
                                            submitMessageReply(
                                              latestMessage,
                                              replyKey
                                            );
                                          }}
                                        >
                                          <div className="com-box-main">
                                            <div className="com-box d-flex mw-notification-message-reply-box">
                                              <textarea
                                                className="mw-notification-reply-input"
                                                value={messageReplyText}
                                                onChange={(event) => {
                                                  setMessageReplyText(
                                                    event.target.value
                                                  );
                                                  setMessageReplyError(null);
                                                }}
                                                placeholder={`Reply to ${latestMessage.user_name}...`}
                                                aria-label={`Reply to ${latestMessage.user_name}`}
                                                rows={3}
                                                required
                                              />
                                            </div>
                                          </div>
                                          {messageReplyError && (
                                            <div
                                              className="mw-notification-reply-error"
                                              role="alert"
                                            >
                                              {messageReplyError}
                                            </div>
                                          )}
                                        </form>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          const obj = row.item;
                          const commentNotificationKey =
                            obj?.type === "c"
                              ? getCommentNotificationKey(obj)
                              : "";
                          const notificationReplyData =
                            obj?.type === "c"
                              ? getNotificationReplyData(
                                  obj,
                                  commentRepliesByNotificationKey
                                )
                              : [];

                          return obj.error != null ? (
                            <div
                              key={`err-${index}`}
                              className="card-mn rounded"
                            >
                              <div className="card-body">{obj.error}</div>
                            </div>
                          ) : (
                            <div
                              key={`${obj.type}-${obj.chat_id}-${obj.chat_reply_id}-${obj.createdon}-${index}`}
                            >
                              {obj.type == "c" && (
                                <div className="card-mn rounded">
                                  <div className="card-body">
                                    <div className="d-flex flex-row">
                                      <div className="notifications-s">
                                        <div className="not-s">
                                          <div className="d-flex">
                                            <div className="flex-shrink-0">
                                              <div className="img-cs">
                                                <a
                                                  href={`/disneyland/user/${obj.user_id}/mypost`}
                                                >
                                                  <img
                                                    src={
                                                      GET_BASE_URL_IMAGE +
                                                      "/disneyland/images/thumbs/" +
                                                      obj.image +
                                                      dTime
                                                    }
                                                    className="card-img-top img-fluid"
                                                    alt="img"
                                                    loading="lazy"
                                                    decoding="async"
                                                  />
                                                </a>
                                              </div>
                                            </div>

                                            <div className="not-text flex-grow-1">
                                              <div className="not-p">
                                                {obj.chat_msg && (
                                                  <span
                                                    className="notification-msg-html"
                                                    dangerouslySetInnerHTML={{
                                                      __html: obj.chat_msg
                                                        ?.replace("<p>", "<span>")
                                                        .replace("</p>", "</span>")
                                                        .replace("<br>", ""),
                                                    }}
                                                  ></span>
                                                )}
                                                <span className="notification-user-row">
                                                  <a
                                                    className="notification-user-link"
                                                    href={`/disneyland/user/${obj.user_id}/mypost`}
                                                  >
                                                    {obj.user_name}
                                                  </a>

                                                  <span className="com-tt">
                                                    {" "}
                                                    {obj.rank} {obj.position}
                                                  </span>
                                                </span>
                                                <span className="com-tt notification-date-row">
                                                  {converDate(obj.createdon)}
                                                </span>
                                                <span
                                                  className="not-1 item-lisst notification-action-row mw-comment-actions"
                                                >
                                                  <button
                                                    type="button"
                                                    className="mw-comment-action"
                                                    onClick={() =>
                                                      openModal(
                                                        obj.chat_reply_id
                                                      )
                                                    }
                                                  >
                                                    Flag
                                                  </button>

                                                  <>
                                                    <LikeCommentReply
                                                      likecount={
                                                        obj.no_of_likes
                                                      }
                                                      chat_id={obj.chat_id}
                                                      comment_id={
                                                        obj.chat_reply_id
                                                      }
                                                      reply_id={""}
                                                      commnet_userid={
                                                        obj.user_id
                                                      }
                                                      type={"C"}
                                                      page={"DL"}
                                                    />
                                                  </>
                                                  <button
                                                    type="button"
                                                    className="mw-comment-action"
                                                    onClick={() =>
                                                      toggleReplyFor(
                                                        obj.chat_id,
                                                        obj.chat_reply_id
                                                      )
                                                    }
                                                  >
                                                    Public Reply
                                                  </button>
                                                  {loginuser == obj?.user_id ? (
                                                    <>
                                                      {/*  <span>Edit</span> */}
                                                      <button
                                                        type="button"
                                                        className="mw-comment-action"
                                                        onClick={(e) => {
                                                          if (
                                                            window.confirm(
                                                              "Are you sure?"
                                                            )
                                                          )
                                                            onRemove(
                                                              obj.chat_reply_id
                                                            );
                                                        }}
                                                      >
                                                        Delete
                                                      </button>
                                                    </>
                                                  ) : (
                                                    /*   */ <></>
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        {/*      <CommentReply
                                          replyData={
                                            obj.comments[0].commentsreply
                                          }
                                          replyShow={showReply}
                                          chatId={obj.chat_id}
                                          chat_reply_id={obj.chat_reply_id}
                                          stickerData={stickerItems}
                                        /> */}

                                        <div className="not-det not-det--right">
                                          <Link
                                            className="not-det__link not-det__link--small"
                                            to={`/${
                                              obj?.chat_room_name === "WDW"
                                                ? "disneyworld"
                                                : "disneyland"
                                            }/lands-talk/${
                                              obj.chat_id
                                            }/${obj.chat_msg?.replace(
                                              /<[^>]*>?/gm,
                                              "-"
                                            )}`}
                                          >
                                            Detail Page
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    {commentReplyLoadingByNotificationKey[
                                      commentNotificationKey
                                    ] && (
                                      <div className="mw-notification-thread-loading">
                                        Loading replies...
                                      </div>
                                    )}
                                    <CommentReply
                                      replyData={notificationReplyData}
                                      replyShow={
                                        activeReplyKey ===
                                        `${String(obj.chat_id)}:${String(
                                          obj.chat_reply_id
                                        )}`
                                      }
                                      chatId={obj.chat_id}
                                      chat_reply_id={obj.chat_reply_id}
                                      stickerData={stickerItems}
                                      parentCommentUserName={obj.user_name}
                                      parentCommentText={obj.chat_msg}
                                      replyTargetUserName={obj.user_name}
                                      onCancelReply={() =>
                                        setActiveReplyKey(null)
                                      }
                                      onReplySubmitted={(replyData) => {
                                        if (Array.isArray(replyData)) {
                                          setCommentRepliesByNotificationKey(
                                            (previous) => ({
                                              ...previous,
                                              [commentNotificationKey]:
                                                replyData,
                                            })
                                          );
                                        }
                                        setActiveReplyKey(null);
                                        loadNotificationCommentThread(obj);
                                        loadNotifications();
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {obj.type == "n" && (
                                <div className="card-mn rounded">
                                  <div className="card-body">
                                    <div className="d-flex flex-row">
                                      <div className="notifications-s">
                                        <div className="not-s">
                                          <div className="d-flex">
                                            <div className="flex-shrink-0">
                                              <div className="img-cs">
                                                <a
                                                  href={`/disneyland/user/${obj.user_id}/mypost`}
                                                >
                                                  <img
                                                    src={
                                                      GET_BASE_URL_IMAGE +
                                                      "/disneyland/images/thumbs/" +
                                                      obj.image +
                                                      dTime
                                                    }
                                                    className="card-img-top img-fluid"
                                                    alt="img"
                                                    loading="lazy"
                                                    decoding="async"
                                                  />
                                                </a>
                                              </div>
                                            </div>

                                            <div className="not-text flex-grow-1">
                                              <div className="not-p">
                                                <div>
                                                  You were tagged in this{" "}
                                                  <Link
                                                    className="text-black"
                                                    style={{
                                                      marginLeft: "0rem",
                                                    }}
                                                    to={`/disneyland/lands-talk/${
                                                      obj.chat_id
                                                    }/${obj.chat_msg?.replace(
                                                      / /g,
                                                      "-"
                                                    )}`}
                                                  >
                                                    post
                                                  </Link>{" "}
                                                  by
                                                  <Link
                                                    className="text-black"
                                                    style={{
                                                      marginLeft: "0.5rem",
                                                    }}
                                                    to={`/disneyland/user/${obj.user_id}/mypost`}
                                                  >
                                                    {obj?.user_name}
                                                  </Link>
                                                  <br />
                                                  <span
                                                    className="com-tt"
                                                    style={{
                                                      marginLeft: ".5rem",
                                                      fontSize: "smaller",
                                                    }}
                                                  >
                                                    {" "}
                                                    {converDate(obj.createdon)}
                                                  </span>
                                                </div>

                                                {obj.chat_msg && (
                                                  <span
                                                    className="notification-msg-html"
                                                    style={{
                                                      fontFamily: "Inter",
                                                      fontSize: "1rm",
                                                      marginRight: "1rem",
                                                      fontWeight: 400,
                                                      fontStyle: "normal",
                                                      color: "#313237",
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                      __html: obj.chat_msg
                                                        ?.replace(
                                                          "<p>",
                                                          "<span>"
                                                        )
                                                        .replace(
                                                          "</p>",
                                                          "</spam>"
                                                        )
                                                        .replace("<br>", ""),
                                                    }}
                                                  ></span>
                                                )}

                                                <span className="not-1 item-lisst notification-action-row mw-comment-actions">
                                                  <Link
                                                    className="mw-comment-action"
                                                    to={`/disneyland/lands-talk/${
                                                      obj.chat_id
                                                    }/${obj.chat_msg?.replace(
                                                      / /g,
                                                      "-"
                                                    )}`}
                                                  >
                                                    Detail Page
                                                  </Link>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                    {myNotificationItem.length > 0 && (
                      <div className="pagination">
                        <button onClick={() => prev()} title="previous">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-arrow-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                            />
                          </svg>
                        </button>

                        <button onClick={() => next()} title="next">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
